import { styled, Toolbar as MuiToolbar, ToolbarProps as MuiToolbarProps } from "@mui/material";

const AppToolbar = styled(MuiToolbar)<MuiToolbarProps>(({ theme }) => ({
    marginLeft: theme.custom.margin.left.appToolbar,
    width: theme.custom.width.appToolbar,
}));

export default AppToolbar;
